
{
  "add": "Add Feature",
  "delete": "Delete feature",
  "labels": {
    "features": "Features",
    "title": "Title"
  }
}
